import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function useApplyTheme() {
  const theme = useSelector((state) => state.theme.current);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);
}
